import { ApplicationConfig, importProvidersFrom } from '@angular/core'
import { provideRouter } from '@angular/router'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'

import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { provideAnalytics } from '@angular/fire/analytics'
import { provideAuth, getAuth } from '@angular/fire/auth'
import { provideStorage, getStorage } from '@angular/fire/storage'
import { provideFirestore, getFirestore } from '@angular/fire/firestore'
import { provideNgxMask } from 'ngx-mask'

import { routes } from './app-routing.module'
import { environment } from 'src/environments/environment'
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations'
import { ThemeOptions } from './theme-options'
import { AuthInterceptor } from './core/interceptors/auth.interceptor'
import { provideServiceWorker } from '@angular/service-worker'
import { createAnalytics } from './core/services/analytics.service'

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        importProvidersFrom([
            HttpClientModule,
            BrowserAnimationsModule
        ]),
        ThemeOptions,
        provideAnimations(),
        provideNgxMask(),

        // HTTP Interceptors
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },

        // Firebase providers
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),
        // Only registered when enabled, so stg/qa never initialise GA at all
        ...(environment.firebase.enableAnalytics ? [provideAnalytics(() => createAnalytics())] : []),
        provideStorage(() => getStorage()),
        provideFirestore(() => getFirestore()),

        // Service Worker (enabled in production/staging only)
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.serviceWorkerEnabled,
            registrationStrategy: 'registerWhenStable:30000'
        })
    ]
}
